import isString from 'lodash/isString';

const validationRegExp = /[0-9a-fA-F]{24}/i;

export const validateVariationId = (variationId) => {
    if (isString(variationId)) {
        return validationRegExp.test(variationId);
    }

    return false;
};
